import React from 'react';

// Petit badge NutriScore rond, réutilisable (classement, prix malbouffe, etc.)
export default function NutriScoreBadge({ score, size = 40 }) {
  const imageScore = Math.min(5, Math.max(1, Math.round(score ?? 1)));

  const levels = [
    { color: '#018240', letter: 'A' },
    { color: '#84bc2d', letter: 'B' },
    { color: '#fdc705', letter: 'C' },
    { color: '#ef7c00', letter: 'D' },
    { color: '#e03d0b', letter: 'E' },
  ];

  const scoreToIndex = {
    5: 0,
    4: 1,
    3: 2,
    2: 3,
    1: 4,
  };

  const activeIndex = scoreToIndex[imageScore] ?? 0;
  const currentLevel = levels[activeIndex] || levels[0];
  const baseAngles = [-126, -54, 18, 90, 162]; // mêmes angles que le score d'analyse, vert centré en haut

  const outerRadius = 54;
  const whiteRadius = 49;
  const innerRadius = 48;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Bordure en 5 arcs de même longueur, avec l'arc actif aligné en haut */}
      <circle
        cx="60"
        cy="60"
        r={outerRadius}
        fill="none"
        stroke="#018240"
        strokeWidth="10"
        strokeDasharray="67.9 271.4"
        transform={`rotate(${baseAngles[0]} 60 60)`}
      />
      <circle
        cx="60"
        cy="60"
        r={outerRadius}
        fill="none"
        stroke="#85bb2f"
        strokeWidth="10"
        strokeDasharray="67.9 271.4"
        transform={`rotate(${baseAngles[1]} 60 60)`}
      />
      <circle
        cx="60"
        cy="60"
        r={outerRadius}
        fill="none"
        stroke="#fecb01"
        strokeWidth="10"
        strokeDasharray="67.9 271.4"
        transform={`rotate(${baseAngles[2]} 60 60)`}
      />
      <circle
        cx="60"
        cy="60"
        r={outerRadius}
        fill="none"
        stroke="#ee8005"
        strokeWidth="10"
        strokeDasharray="67.9 271.4"
        transform={`rotate(${baseAngles[3]} 60 60)`}
      />
      <circle
        cx="60"
        cy="60"
        r={outerRadius}
        fill="none"
        stroke="#e63e0f"
        strokeWidth="10"
        strokeDasharray="67.9 271.4"
        transform={`rotate(${baseAngles[4]} 60 60)`}
      />

      {/* Bord blanc fin entre bordure et rond central */}
      <circle
        cx="60"
        cy="60"
        r={whiteRadius}
        fill="#ffffff"
      />

      {/* Rond central coloré */}
      <circle cx="60" cy="60" r={innerRadius} fill={currentLevel.color} />
      <text
        x="60"
        y="64"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#ffffff"
        fontSize="40"
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        fontWeight="700"
      >
        {currentLevel.letter}
      </text>
    </svg>
  );
}

